module.exports = __webpack_public_path__ + "static/media/background_2x.0af6e444.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/cities/new-york-city/background_2x.jpg
// module id = 898
// module chunks = 27